<h3 style="text-align: center; font-size: 1.77rem; font-weight: 700;font-family: 'Poppins', sans-serif;">
    Transferencias
</h3>
<app-main-buscar-filter
    [num_trab_finiquitados]="num_trab_finiquitados"
    (textSearch)="applyFilter($event)"
    (viewFiniquitadosEmit)="viewDatosFiniquitados($event)">
</app-main-buscar-filter>
<!-- <div class="row container-fluid">
    <div class="mr-2">
        <mat-form-field appearance="outline">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
    </div>
    <div class="d-flex align-items-center">
        <mat-checkbox (change)="viewDatosFiniquitados()" [(ngModel)]="viewFiniquitados" color="warn">
            <span [matBadge]="num_trab_finiquitados <= 99
                ? num_trab_finiquitados
                : '+99'"
                matBadgeOverlap="false">Mostrar trabajadores finiquitados</span>
        </mat-checkbox>
    </div>
</div> -->
<table mat-table id="tabla" [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="announceSortChange($event)" #tabla>
    <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FOLIO </th>
        <td mat-cell *matCellDef="let element" class="font-semibold"> {{ element.folio }} </td>
    </ng-container>
    <ng-container matColumnDef="rut">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> RUT </th>
        <td mat-cell *matCellDef="let element" class="font-semibold"> {{ element.rut | formatoRut }} </td>
    </ng-container>
    <ng-container matColumnDef="nombres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE COMPLETO </th>
        <td mat-cell *matCellDef="let element" class="font-semibold"> {{element.nombres | titlecase}} {{element.apellidos | titlecase}} </td>
    </ng-container>

    <ng-container matColumnDef="empresa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> EMPRESA</th>
        <td mat-cell *matCellDef="let element">{{ element.Empresa_contratante.nombre | titlecase}}</td>
    </ng-container>

    <ng-container matColumnDef="estado_contrato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTADO CONTRATO</th>
        <td mat-cell *matCellDef="let element">
            <span [ngClass]="{'bg-danger p-1 rounded text-light': element.estado_contrato === 'Finiquitado'}">{{element.estado_contrato | titlecase}}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
        <td mat-cell *matCellDef="let element">

          <p-button class="mr-2" (click)="mostrar(contenido2,element)" icon="pi pi-folder-open" styleClass="p-button-rounded p-button-warning p-button-outlined" ></p-button>

          <p-button *ngIf="!isAuditor" class="mr-2" (click)="subir(contenido,element)" icon="pi pi-upload" styleClass="p-button-rounded p-button-primary p-button-outlined" ></p-button>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons aria-label="Seleccionar pagina de usuarios.">
</mat-paginator>

<!-- modales -->
<!-- modal subir -->
<ng-template style="border: 0px; z-index: 100" #contenido let-modal2>
    <div class="modal-header" style="text-align: center">
        <h4>Subir Transferencias</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal2.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <!-- <app-agregar-doctransferencias [rut]="rut_trabajador"></app-agregar-doctransferencias> -->
        <app-agregar-doctransferencias [trabajador]="datosTrabajador"></app-agregar-doctransferencias>
    </div>
</ng-template>

<!-- modal mostrar -->
<ng-template style="border: 0px; z-index: 100" #contenido2 let-modal3>
    <div class="modal-header" style="text-align: center">
        <h4>Mostrar Transferencias</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal3.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <!-- <app-modal-mostrar [rut]="rut_trabajador"></app-modal-mostrar> -->
        <app-modal-mostrar [trabajador]="datosTrabajador"></app-modal-mostrar>
    </div>
</ng-template>
